import axios from 'axios'
import { getAuth } from '../modules/auth/core/AuthHelpers'

const API_URL = process.env.REACT_APP_API_URL

export const axiosClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

export const axiosClientAuth = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Use request interceptor to read fresh token on each request (fixes login without refresh)
axiosClientAuth.interceptors.request.use(
  (config) => {
    const auth = getAuth()
    const token = auth?.access_token || (auth as any)?.token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (err) => Promise.reject(err)
)
